export * from './post-abschnitt.component';
export * from './post-abschnitt.component.module';